import script from "./MatchReport.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchReport.vue?vue&type=script&setup=true&lang=js"

import "./MatchReport.vue?vue&type=style&index=0&id=3aa07f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa07f88"]])

export default __exports__